import { useQuery } from '@apollo/client';
import { gql } from '@apollo/client/core';

const GET_SETTING = gql`
  query BusinessHoursSettingList {
    businessHoursSettings {
      nodes {
        dayName
        startTime
        endTime
        enabled
      }
    }
  }
`;

export const useGetSettings = () => {
  const { loading, error, data, refetch } = useQuery(GET_SETTING);

  if (data) {
    console.log(
      'DEBUG: Backend returned settings:',
      JSON.stringify(data, null, 2)
    );
  }

  return { loading, error, data, refetch };
};
